import { Feature, Polygon } from '@turf/turf';

export function processPolygonData(data: any): Feature<Polygon>[] {
  try {
    // If data is a FeatureCollection from MapboxDraw
    if (data.type === 'FeatureCollection' && Array.isArray(data.features)) {
      return data.features.filter(f => 
        f?.type === 'Feature' && 
        f?.geometry?.type === 'Polygon'
      );
    }

    // If data is already an array of polygon features
    if (Array.isArray(data)) {
      return data.filter(f => 
        f?.type === 'Feature' && 
        f?.geometry?.type === 'Polygon'
      );
    }

    // If data is a single polygon feature
    if (data.type === 'Feature' && data.geometry?.type === 'Polygon') {
      return [data];
    }

    console.error('Invalid polygon data structure:', data);
    throw new Error('Invalid polygon data structure');
  } catch (error) {
    console.error('Error processing polygon data:', error);
    throw error;
  }
}